import {
  List,
  Datagrid,
  ChipField,
  ReferenceField,
  BooleanInput,
  BooleanField,
  TextField,
  ImageField,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  TextInput,
  ImageInput,
  Create,
  SelectInput,
  Show,
  SimpleShowLayout,
  RichTextField,
  DateField,
  required,
} from 'react-admin'

import { CustomRichTextInput } from '../components/CustomRichTextInput'

import { USER_TYPE_OPTIONS, PHASE_TYPE_OPTIONS, GOAL_OPTIONS } from '../config/constants'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const OfferList = ({ isEdit, isDelete }) => (
  <List>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? "edit" : "show"}>
      <ChipField source="userType" />
      <BooleanField source="isOverweight" />
      <ChipField source="phaseType" />
      {/*<ReferenceField source="phaseId" reference="phases" />*/}
      <ChipField source="goal" />
      <DateField source="updatedAt" label="Updated At" showTime />
      <ReferenceField source="updatedBy" reference="users" />
      {/*<ImageField source="imageUrl" title="imageUrl" />*/}
      {isDelete && <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />}
    </Datagrid>
  </List>
)

export const OfferEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="title" fullWidth multiline />
      <CustomRichTextInput size="medium" source="text" fullWidth />
      <TextInput source="buttonText" fullWidth multiline />
      <ImageField source="imageUrl" title="imageUrl" />
      <ImageInput source="image">
        <ImageField source="src" title="title" />
      </ImageInput>
    </SimpleForm>
  </Edit>
)

export const OfferCreate = () => (
  <Create>
    <SimpleForm>
      <SelectInput validate={required()} source="userType" choices={USER_TYPE_OPTIONS} />
      <BooleanInput source="isOverweight" label="Is Overweight" validate={required()} />
      <SelectInput validate={required()} source="phaseType" choices={PHASE_TYPE_OPTIONS} />
      <SelectInput validate={required()} source="goal" choices={GOAL_OPTIONS} />
      <TextInput source="title" fullWidth multiline validate={required()} />
      <CustomRichTextInput size="medium" source="text" fullWidth validate={required()} />
      <TextInput source="buttonText" fullWidth multiline validate={required()} />
      <ImageField source="imageUrl" title="imageUrl" />
      <ImageInput source="image">
        <ImageField source="src" title="title" />
      </ImageInput>
    </SimpleForm>
  </Create>
)

export const OfferShow = () => (
  <Show>
    <SimpleShowLayout>
      <ChipField source="userType" />
      <BooleanField source="isOverweight" />
      <ChipField source="phaseType" />
      {/*<ReferenceField source="phaseId" reference="phases" />*/}
      <ChipField source="goal" />
      <TextField source="title" fullWidth multiline />
      <RichTextField source="text" fullWidth multiline />
      <TextField source="buttonText" fullWidth multiline />
      <ImageField source="imageUrl" title="imageUrl" />
      <DateField source="updatedAt" label="Updated At" showTime />
      <ReferenceField source="updatedBy" reference="users" />
    </SimpleShowLayout>
  </Show>
)
